import { HEADER_TEST_IDENTIFIER } from 'components/Layout/Header/Header';
import { B2bLogo } from 'components/Layout/Header/HeaderTop/Logo/B2bLogo';
import useTranslation from 'next-translate/useTranslation';

export const SimpleB2bHeader: FC = () => {
    const { t } = useTranslation();

    return (
        <div className="vl:menu-gradient relative z-menu mb-5 bg-primary" data-testid={HEADER_TEST_IDENTIFIER}>
            <div className="flex w-full flex-wrap justify-between vl:px-5 xl:mx-auto xl:w-layout">
                <div className="flex h-11 flex-1 items-center justify-between vl:h-16 vl:shrink-0 vl:grow vl:basis-full">
                    <B2bLogo linkText={t('Go to homepage')} />
                </div>
            </div>
        </div>
    );
};
